import { render, staticRenderFns } from "./BarChartTamanho.vue?vue&type=template&id=623b2f14"
import script from "./BarChartTamanho.vue?vue&type=script&lang=js"
export * from "./BarChartTamanho.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports